import { datajs, datajsAll } from '../shared/utils';
import Swiper, { FreeMode, Pagination } from 'swiper';

export default class CardCollection {
	static init() {
		const cardCollections = datajsAll('card-collection');
		const breakpoint = window.matchMedia('(max-width: 991px)');

		if (cardCollections.length === 0) {
			return;
		}

		const breakpointChecker = () => {
			if (breakpoint.matches) {
				cardCollections.forEach((collection) => {
					this.setupSwiperInstance(collection);
				});
			} else {
				cardCollections.forEach((collection) => {
					this.destroySwiperInstance(collection);
				});
			}
		};

		breakpoint.addEventListener('change', breakpointChecker);
		breakpointChecker();
	}

	static destroySwiperInstance(collection) {
		const swiperWrapper = datajs('swiper-wrapper', collection);
		const swiperSlides = datajsAll('swiper-slide', collection);
		const swiper = collection.swiper;

		if (swiper !== undefined) {
			swiper.destroy();
		}

		// Remove wrapper class
		swiperWrapper.classList.remove('swiper-wrapper');

		// Add Bootstrap row class
		swiperWrapper.classList.add('row');

		// Remove individual slide classes
		swiperSlides.forEach((slide) => {
			slide.classList.remove('swiper-slide');
		});
	}

	static setupSwiperInstance(collection) {
		const swiperWrapper = datajs('swiper-wrapper', collection);
		const swiperSlides = datajsAll('swiper-slide', collection);

		// Add wrapper class
		swiperWrapper.classList.add('swiper-wrapper');

		// Remove Bootstrap row class
		swiperWrapper.classList.remove('row');

		// Add individual slide classes
		swiperSlides.forEach((slide) => {
			slide.classList.add('swiper-slide');
		});

		// eslint-disable-next-line no-new
		const carouselInstance = new Swiper(collection, {
			modules: [FreeMode, Pagination],
			init: false,
			speed: 500,
			slidesPerView: 'auto',
			freeMode: true,
			spaceBetween: 16,

			pagination: {
				el: datajs('card-collection-pagination', collection),
				bulletClass: 'm-sliderPagination__item',
				bulletActiveClass: 'is-active',
				clickable: true,
			},
		});

		carouselInstance.init();
	}
}
